const placeholderImages = [
  "/images/profile-default-2.jpg",
  "/images/profile-default-3.jpg",
  "/images/profile-default-4.jpg",
];
const alphabet = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0",
];

const getRandomProfile = (name: string) => {
  let index = alphabet.indexOf(name.charAt(0).toUpperCase());
  if (index === -1) {
    index = 0;
  }
  const path = placeholderImages[index % placeholderImages.length];
  return window.location.origin + path;
};
export default getRandomProfile;
